<!-- <nav id="navbar-mobile" class="navbar navbar-expand-lg navbar-light bg-light">
  
    <button class="navbar-toggler pull-right" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <a href="../">
        <img id="logo-img" src="assets/img/small-logo.png" alt="logo">
    </a>
  
    <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
      <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
        <li class="nav-item active">
          <a class="nav-link" href="#">Home <span class="sr-only">(current)</span></a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#">Link</a>
        </li>
        <li class="nav-item">
          <a class="nav-link disabled" href="#">Disabled</a>
        </li>
      </ul>
    </div>
  </nav> -->

<nav id="navbar-mobile" class="navbar navbar-expand-lg navbar-light bg-light">
    <a class="navbar-brand" href="#"><img id="logo-img" src="assets/img/black-logo.png" alt="logo"></a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#main_nav">
        <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="main_nav">
        <!-- <ul class="navbar-nav">
            <li class="nav-item active"> <a class="nav-link" href="#">Home </a> </li>
            <li class="nav-item"><a class="nav-link" href="#"> About </a></li>
            <li class="nav-item"><a class="nav-link" href="#"> Services </a></li>
            <li class="nav-item dropdown">
                <a class="nav-link  dropdown-toggle" href="#" data-toggle="dropdown"> More items </a>
                <ul class="dropdown-menu">
                    <li><a class="dropdown-item" href="#"> Submenu item 1</a></li>
                    <li><a class="dropdown-item" href="#"> Submenu item 2 </a></li>
                </ul>
            </li>
        </ul> -->
        <ul class="navbar-nav">
                <li class="nav-item"><a routerLink="/" class="nav-link" [ngClass]="{'active':pageIndex === 0}">{{home}}</a>
                </li>
        
                <li class="nav-item dropdown">
                    <a href="javascript:;" class="nav-link  dropdown-toggle"  [ngClass]="{'active':pageIndex === 1}" href="#" data-toggle="dropdown">{{aboutEdu}}</a>
                    <ul class="dropdown-menu">
                        <li><a  routerLink="/other/profile" class="dropdown-item">{{profile}}</a></li>
        
                        <li><a routerLink="/instructors" class="dropdown-item">{{instructor}}</a></li>
        
                        <li><a routerLink="/partners" class="dropdown-item">{{partner}}</a>
                        </li>
        
                        <li><a routerLink="/other/feedback" class="dropdown-item">{{feedback}}</a>
                        </li>
        
                        <li><a routerLink="/other/faq" class="dropdown-item">{{faq}}</a>
                        </li>
        
                        <li><a routerLink="/other/user-guide" class="dropdown-item">{{userGuide}}</a>
                        </li>
        
                    </ul>
                </li>
        
                <li class="nav-item"><a  routerLink="/courses" class="nav-link" [ngClass]="{'active':pageIndex === 2}">{{courses}}</a>
        
                </li>
        
                <li class="nav-item">
                    <a routerLink="/lessons" class="nav-link" [ngClass]="{'active':pageIndex === 3}">{{englishLesson}}
                    </a>
                </li>
        
                <li class="nav-item"><a routerLink="/knowledges" class="nav-link" [ngClass]="{'active':pageIndex === 4}">{{knowledge}}</a>
        
                </li>

        
                <li class="nav-item"><a routerLink="/contact" class="nav-link" [ngClass]="{'active':pageIndex === 5}">{{contact}}</a></li>


                <li class="nav-item"><a routerLink="/phrasalverbs" class="nav-link" [ngClass]="{'active':pageIndex === 6}">{{dictionary}}</a>
        
                </li>
            </ul>
    </div> <!-- navbar-collapse.// -->
</nav>

<!-- Start Navbar Area -->
<div id="navbar-desktop" [ngClass]="setClasses()">
        <div class="raque-responsive-nav">
            <div class="container">
                <div class="raque-responsive-menu">
                    <div class="logo">
                        <a routerLink="/">
                            <!-- <img  src="assets/img/black-logo.png" alt="logo"> -->
                        </a>
                    </div>
                   
                </div>
                
            </div>
        </div>
        <app-menu [lessons]="lessons"></app-menu> 
    </div>
    <!-- End Navbar Area -->
    
    <!-- Start Sticky Navbar Area -->
    <div class="navbar-area navbar-style-three header-sticky">
        <app-menu [lessons]="lessons"></app-menu> 
    </div>
    <!-- End Sticky Navbar Area -->

